import { resolveComponent as t, createElementBlock as n, openBlock as r, createElementVNode as s, createVNode as c, createTextVNode as a } from "vue";
import { _ } from "../plugin-vue.CHgC5LLL.js";
const i = {}, m = { class: "alert alert-warning" }, d = { class: "lead mb-0" };
function l(f, e) {
  const o = t("font-awesome-icon");
  return r(), n("div", m, [
    s("p", d, [
      c(o, { icon: "fa-warning" }),
      e[0] || (e[0] = a(" Sorry, this page doesn't exist. "))
    ])
  ]);
}
const N = /* @__PURE__ */ _(i, [["render", l]]);
export {
  N
};
